import styles from "./SignatureModal.module.css";
import { Gifs } from "@/assets/gifs";
import { Modal } from "@/shared/modal";

export type ProtestSuccessModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  onContinue: () => void;
  redirectSeconds: number;
};

export const ProtestSuccessContent = ({
  onContinue,
  redirectSeconds,
}: Omit<ProtestSuccessModalProps, "isOpen" | "onClose">) => {
  return (
    <div className={styles.kycCard}>
      <div className={styles.successCard}>
        <div className={styles.successTopText}>Congratulations on taking the first big step!</div>
        <div className={styles.successHeadline}>YOUR PROTEST HAS BEEN FILED</div>
        <img src={Gifs.andyBigFlex2} alt="Andy celebrating" className={styles.successGif} />
        <div className={styles.successMessage}>
          Great job! All forms have been signed. Now, let&apos;s build a stronger protest with more
          supporting evidence.
        </div>
        <button type="button" className={styles.successContinueBtn} onClick={onContinue}>
          Continue
        </button>
        <div className={styles.successRedirectText}>
          Redirecting to file upload in <span>{redirectSeconds}</span> seconds...
        </div>
      </div>
    </div>
  );
};

export const ProtestSuccessModal = ({
  isOpen,
  onClose,
  onContinue,
  redirectSeconds,
}: ProtestSuccessModalProps) => {
  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose || (() => {})}
      showCloseButton={false}
      closeOnBackdropClick={false}
      unconstrained
      className={styles.content}
      bodyClassName={styles.continueModalBody}
      ariaLabel="Success details"
    >
      <ProtestSuccessContent onContinue={onContinue} redirectSeconds={redirectSeconds} />
    </Modal>
  );
};
